/* ═══ 共用分頁組件（Captain 2026-09-12 指示）═══
 * 規則：後台任何 list 一律每頁 10 筆（PAGE_SIZE 常數單一真相源）。
 * 新 list 頁用法：
 *   const pageData = useMemo(() => data.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE), [data, page]);
 *   {pageData.map(...)}
 *   <Pager page={page} totalPages={Math.max(1, Math.ceil(data.length / PAGE_SIZE))} onChange={setPage} /> */
export const PAGE_SIZE = 10;

export default function Pager({
  page,
  totalPages,
  onChange,
  total,
}: {
  page: number; // 0-based
  totalPages: number;
  onChange: (p: number) => void;
  total?: number; // 顯示總筆數（可選）
}) {
  if (totalPages <= 1) {
    return total !== undefined ? (
      <p className="text-xs text-slate-500 mt-3">共 {total} 筆</p>
    ) : null;
  }
  return (
    <div className="flex items-center justify-center gap-3 mt-4 text-sm">
      <button
        onClick={() => onChange(Math.max(0, page - 1))}
        disabled={page === 0}
        className="px-3 py-1.5 rounded-lg border border-slate-700 hover:border-slate-500 disabled:opacity-40 disabled:cursor-default text-slate-300 text-xs"
      >
        ← 上一頁
      </button>
      <span className="text-xs text-slate-400 font-mono">
        第 {page + 1} / {totalPages} 頁{total !== undefined ? `（共 ${total} 筆）` : ""}
      </span>
      <button
        onClick={() => onChange(Math.min(totalPages - 1, page + 1))}
        disabled={page >= totalPages - 1}
        className="px-3 py-1.5 rounded-lg border border-slate-700 hover:border-slate-500 disabled:opacity-40 disabled:cursor-default text-slate-300 text-xs"
      >
        下一頁 →
      </button>
    </div>
  );
}
